import React from "react";
import styled from "styled-components";
import { isEmpty } from "lodash";
import {
  selectDiscovery,
  selectDiscoveryId,
  selectRequestData
} from "../../store/reducers";
import { compose } from "redux";
import { connect } from "react-redux";
import Link from "../../components/RouterLink";
import { Space } from "antd";
import Icon from "../../components/Icon";
import { useParams, withRouter } from "react-router-dom";
import { useString as s } from "../../components/StringProvider";
import Text from "../../components/Text";
import actionType from "../../store/actionTypes";
import { Tooltip } from "../../components";

const QuestionsNavigator = ({ discoveryId, discovery, isNextDisabled }) => {
  const { questionNumber } = useParams();
  const currentQuestionNumber = parseInt(questionNumber);
  const currentAnswer = discovery?.questions?.[currentQuestionNumber]?.answer;

  const previousQuestionTooltip = s(
    "discovery.questions.previous.tooltip",
    "Previous question"
  );

  const answerQuestionTooltip = s(
    "discovery.questions.nextNotAnswered.tooltip",
    "Answer the question to continue"
  );
  const nextQuestionTooltip = s(
    "discovery.questions.nextAnswered.tooltip",
    "Next question"
  );

  const getQuestions = () => {
    let questions = [];
    let numberDisplayCounter = 1;
    for (let i = 0; i < discovery.questions.length; i++) {
      let question = discovery.questions[i];
      if (question.active) {
        question.numberDisplay = numberDisplayCounter;
        numberDisplayCounter++;
      }
      question.arrayPosition = i;
      questions.push(question);
    }
    return questions;
  };

  const questions = getQuestions();
  const numberDisplay = questions[questionNumber].numberDisplay;
  let activeQuestions = questions.filter((question) => question.active);

  const questionText = s(
    "discovery.questions.navigator.text",
    "Question {current} of {total}",
    {
      current: numberDisplay,
      total: activeQuestions.length
    }
  );

  const getNext = () => {
    for (let i = currentQuestionNumber + 1; i < questions.length; i++) {
      if (questions[i].active) {
        return questions[i];
      }
    }

    return undefined;
  };

  const getPrevious = () => {
    for (let i = currentQuestionNumber - 1; i >= 0; i--) {
      if (questions[i].active) {
        return questions[i];
      }
    }

    return undefined;
  };

  const currentNotAnswered = isEmpty(currentAnswer);
  const previous = getPrevious();
  const next = getNext();

  const PreviousArrow = () => (
    <ArrowContainer>
      <Link
        to={`/discoveries/${discoveryId}/questions/${previous?.arrayPosition}`}
        data-cy={"previous-question-link"}
        data-link={`/discoveries/${discoveryId}/questions/${previous?.arrayPosition}`}
        disabled={previous?.arrayPosition === undefined}
      >
        <Icon name={"arrowLeft2"} size={"large"} />
      </Link>
    </ArrowContainer>
  );

  const NextArrow = () => (
    <ArrowContainer>
      <Link
        to={`/discoveries/${discoveryId}/questions/next`}
        data-cy={"next-question-link"}
        data-link={`/discoveries/${discoveryId}/questions/${next?.arrayPosition}`}
        disabled={isNextDisabled}
      >
        <Icon name={"arrowRight"} size={"large"} />
      </Link>
    </ArrowContainer>
  );

  return (
    <Space direction={"horizontal"} size={24}>
      {previous?.arrayPosition === undefined ? (
        <BlankArrow />
      ) : (
        <Tooltip title={previousQuestionTooltip} placement={"top"}>
          <PreviousArrow />
        </Tooltip>
      )}
      <Text variant={"body"} color={"gray4"}>
        {questionText}
      </Text>
      {isNextDisabled && (
        <Tooltip
          title={
            currentNotAnswered ? answerQuestionTooltip : nextQuestionTooltip
          }
          placement={"top"}
        >
          {NextArrow()}
        </Tooltip>
      )}
      {!isNextDisabled && NextArrow()}
    </Space>
  );
};

const ArrowContainer = styled.div`
  margin-top: 8px;
`;

const BlankArrow = styled.div`
  min-width: 25px;
  min-height: 25px;
`;

const mapStateToProps = (state) => {
  return {
    discoveryId: selectDiscoveryId(state),
    discovery: selectDiscovery(state),
    isNextDisabled: selectRequestData(
      state,
      actionType.DISCOVERY_QUESTION_SUBMIT_DISABLED_SUCCESS
    )
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps)
)(QuestionsNavigator);
